// What a click on a move of the scoresheet does (2026-10-15): the board
// first shows the position the move was played from, and a beat later the
// move is made on it, so the reader watches the piece go (Chessground
// animates the one-move difference between the two positions). Before, the
// click landed on the position before the move and stayed there. Pure:
// `wait` is injected, so the sequence is tested without timers.
import type { Review } from '@chess/api-review';

/** How long the position before the move shows before the move is made: past Chessground's own 200 ms animation of the jump there. */
export const MAKE_MOVE_MS = 450;

export type Wait = (ms: number, fn: () => void) => () => void;

const timer: Wait = (ms, fn) => {
  const id = setTimeout(fn, ms);
  return () => clearTimeout(id);
};

/**
 * Go to the position before move `ply`, then make the move. Returns a
 * cancel for the second step, for a new click or an unmounted sheet. The
 * move is only made if the review is still on that position when the time
 * comes (the reader may have stepped or dragged a piece meanwhile).
 */
export function selectMove(api: Pick<Review, 'go' | 'state'>, ply: number, wait: Wait = timer): () => void {
  const before = Math.max(0, ply - 1);
  api.go(before);
  if (ply <= 0) return () => {};
  return wait(MAKE_MOVE_MS, () => {
    const s = api.state();
    if (s.ply === before && !s.exploring && s.browse === undefined) api.go(ply);
  });
}
